<template>
  <nav class="TipicoCasinoCategories ComponentGameCategories InstanceCasino GameNavContainer TipicoCasino">
    <div class="GameCategoriesSwipe">
      <ul class="GameCategories Loaded CategoriesList HorizontalScrollBar List ListUnordered">
        <li class="CategoriesItem ListItem" v-for="cat in cats">
          <router-link :to="{name: 'Casino', query: {category: cat.id}}" class="ComponentAnchor GameCategory Anchor Anchor " title="Nur bei uns" id="CategoryList-Nur-bei-uns">
            <div class="CategoryNameContainer" id="CategoryList-Nur-bei-uns-Text">{{ cat.name }}</div>
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'categoryList',
  data () {
    return {
      cats: null
    }
  },
  mounted() {
    this.fetchCategory()
  },
  methods: {
    fetchCategory(){
      this.$http.get(bsapi+'api/v1/casino/categories').then(response => {
        // get body data
        this.cats = response.body.result;

      }, response => {
        // error callback
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/casino/widget/categoryList.vue